import { ProductWithQuantity } from '../model';
import { GTMTrackChangeBasket, GTMCartItem } from '../model/TrackingObject';

export type AddToBasketEvent = {
    event: 'eec_add';
    ecommerce: {
        basket_id: string;
        currencyCode?: string;
        add: {
            products: ProductWithQuantity[];
        };
        cartItems?: GTMCartItem[];
    };
};

export const trackAddToBasketEvent = ({
    products,
    cartItems,
    currencyCode,
    basketId
}: GTMTrackChangeBasket): AddToBasketEvent => ({
    event: 'eec_add',
    ecommerce: {
        basket_id: basketId,
        currencyCode,
        add: {
            products,
        },
        cartItems
    },
});
